import React from 'react'
import { db } from '../../firebase'
import {Container, Grid} from 'semantic-ui-react';
import {
    Card,
    CardHeader,
    CardContent,
    Typography,
    
  } from '@mui/material';
import { Box } from '@mui/material';
import { format } from 'date-fns';
import TabSecondary from './TabSecondary';


var history = []


const Dispatchdetails = (props) => {
// console.log(props)
// console.log(props.match.params.id)
const [orderDetails,setOrderDetails ] = React.useState([])
const[dispachtHistory,setDispachtHistory] = React.useState([])

React.useEffect(()=>{
  
    const findOrdesrDispacht = async (id) =>{
      // console.log(id)
      try {
        const ordesDispacht = await db.collection(`${process.env.REACT_APP_COL_ORDERS}`).doc(id).get()
        const resultsHistory =  await db.collection(`${process.env.REACT_APP_COL_ORDERS}`).doc(id).collection('historial').get()
        history = resultsHistory.docs.map(doc => ({id: doc.id, ...doc.data()}))
        // console.log(ordesDispacht.data())
        const Orden = ordesDispacht.data()
        setOrderDetails(Orden)

      } catch (error) {
  
        // console.log(error)
      }
    }

    findOrdesrDispacht(props.match.params.id)

   

  },[])

          
// console.log(orderDetails)

    return (
        <div id="containerDetails" >
        <div>
       <h1>Detalles de despacho</h1> 
        </div>
        <Grid>
        <Grid.Row> 

        <Grid.Column  computer={10} mobile={16} tablet={16}   >



 

        <Card  className="card-ultimasOrdenes typeMiniforms">
              <CardHeader title={<h1>{orderDetails.dispachtCode}</h1>} />
              <CardContent>
              <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                maxWidth:'350',
                }}
               >


                <div><h1>Resumen</h1></div>
                <Container className='formcontent' >
                <TabSecondary props={props} orderDetails={orderDetails}/>
                </Container>

              </Box>
                </CardContent>
        </Card>
        </Grid.Column>

        <Grid.Column  computer={6} mobile={16} tablet={16}   >
        <Card  className="card-ultimasOrdenes typeMiniforms">
        <CardHeader title={<h2>Historial</h2>} />
        <CardContent>
        <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
                }}
               >
                <Container className='formcontent' id="micuentafromIni">
                <div className="alert alert-info">Historial
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Fecha</th>
                            <th scope="col">Estado</th>
                       
                     
                          </tr>
                        </thead>
                        
                        <tbody>
                        {history.map((historyMk) => (
                          <tr key={historyMk.id}>
                            <th  scope="row">{format(historyMk.dispachtStatusChangeDate, 'dd/MM/yy')}
                            </th>
                            <td>{historyMk.issues}</td>
                            </tr>
                            ))}

                        </tbody>
                      </table>
                        
                        </div>
                
                     
                </Container>


              </Box>
        </CardContent>
        </Card>

        <Card  className="card-ultimasOrdenes typeMiniforms">
              <CardHeader title={<h2>Facturación</h2>} />
              <CardContent>
              <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                maxWidth:'350',
                }}
               >
              
                <Container className='formcontent' >
                <hr></hr>
                <Typography color="textPrimary" gutterBottom variant="body">ID:</Typography><Typography color="textPrimary" gutterBottom variant="body">{orderDetails.dispachtCode}</Typography>
                <hr></hr>
                <Typography color="textPrimary" gutterBottom variant="body">Nombre servicio:</Typography><Typography color="textPrimary" gutterBottom variant="body">_________</Typography>
                <hr></hr>
                <Typography color="textPrimary" gutterBottom variant="body">Costo de servicio:</Typography><Typography color="textPrimary" gutterBottom variant="body">_________</Typography>
                <hr></hr>
                </Container>

              </Box>
              </CardContent>
        </Card>
        </Grid.Column>

        </Grid.Row> 
        </Grid>
        </div> 
  )
}

export default Dispatchdetails